import styles from './CoreParagraph.module.scss';
import React from 'react';
import { Content } from '@wienenergiegithub/ui-next';

const CoreParagraph = ({ saveContent, align, noSpacing, groupTheme }) => (
  <Content
    align={align}
    as="div"
    className={styles.scrollMargin}
    noSpacing={noSpacing}
    theme={groupTheme}
    withParser
  >
    {saveContent}
  </Content>
);
CoreParagraph.noMargin = true;
export default CoreParagraph;
